<button
  *ngIf="hasCookieConsent"
  class="cookie-settings-btn"
  (click)="openCookieSettings()"
  [attr.aria-label]="'Cookie Settings'"
  title="Manage Cookie Preferences">
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 11.71 4.02 11.42 4.05 11.14C5.41 11.78 6.96 12.16 8.62 12.16C11.99 12.16 14.96 10.59 16.76 8.14C17.46 9.17 18 10.54 18 12C18 16.41 14.41 20 12 20Z" fill="currentColor"/>
    <circle cx="8" cy="8" r="1.5" fill="currentColor"/>
    <circle cx="15" cy="9" r="1" fill="currentColor"/>
    <circle cx="10" cy="14" r="1" fill="currentColor"/>
  </svg>
  <span class="settings-text d-none d-md-inline">{{ 'common.cookie_settings' | translate }}</span>
</button>
